import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=88353adc&scoped=true"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"
import style0 from "./AdminMain.vue?vue&type=style&index=0&id=88353adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88353adc",
  null
  
)

export default component.exports